import { ONBOARDING_MEXICO_FORM_STEPS } from '.';

export const STAGE_STEPS = {
  BANK_INFORMATION: 'account',
  DOCUMENTS: 'documents',
  BENEFICIAL_OWNERS: 'complete',
};

export const FORM_STEP_FIELDS = {
  [ONBOARDING_MEXICO_FORM_STEPS.BANK_INFORMATION]: STAGE_STEPS.BANK_INFORMATION,
  [ONBOARDING_MEXICO_FORM_STEPS.COMPANY_DOCUMENTATION]: STAGE_STEPS.DOCUMENTS,
  [ONBOARDING_MEXICO_FORM_STEPS.BENEFICIAL_OWNERS]:
    STAGE_STEPS.BENEFICIAL_OWNERS,
};
